import { Typography } from '@mui/material'
import React from 'react'
import IndustriesNavMenu from './IndustriesNavMenu'

export default function Industries() {
  return (
    <>
      <Typography variant="h4" align="center">
        Industries
      </Typography>
      <IndustriesNavMenu />
    </>
  )
}
